import React, { useCallback } from 'react';

import {
  Box,
  useToast as useChakraToast,
  UseToastOptions,
} from '@chakra-ui/react';

export enum ToastTypesEnum {
  success = 'success',
  error = 'error',
}

const colors = {
  toast: {
    success: '#009656',
    error: '#E22F2F',
    text: '#FFFFFF',
  },
};

export const useToast = () => {
  const toast = useChakraToast();

  const customToast = useCallback(
    (
      message: string | React.ReactNode,
      type: ToastTypesEnum,
      params?: UseToastOptions
    ) => {
      toast({
        position: 'top',
        isClosable: true,
        duration: 3000,
        ...params,
        render: () => (
          <Box
            bg={
              type === ToastTypesEnum.success
                ? colors.toast.success
                : colors.toast.error
            }
            color={colors.toast.text}
            fontWeight="bold"
            p={3}
          >
            {message}
          </Box>
        ),
      });
    },
    [toast]
  );

  return customToast;
};
